/**
 * TableHeadTableCell
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';

// Actions
import { updateQueryString } from '../../services/router/actions';

// Workspaces
import { makeSelectQueryStringValue } from '../../workspaces/react-router-selectors';

interface Props {
    updateQueryString: Function;
    sort?: string;
    label: string | React.Node;
    value: string;
    defaultSort?: string;
    namespace?: string;
    style?: Record<string, any>;
}

export class TableHeadTableCell extends React.PureComponent<Props> {
    get sort() {
        const { sort, defaultSort } = this.props;
        return sort || defaultSort;
    }

    get currentValue() {
        const { sort } = this;
        if (!sort) return undefined;
        const attributes = sort.split('_');
        return attributes[0];
    }

    get direction() {
        const { sort } = this;
        if (!sort) return undefined;
        const attributes = sort.split('_');
        return attributes[1] || 'ascending';
    }

    get isActive() {
        const { value } = this.props;
        return this.currentValue === value;
    }

    handleClick = () => {
        const { value, namespace } = this.props;

        this.props.updateQueryString({
            [`${namespace ? `${namespace}_` : ''}sort`]: `${value}_${
                this.isActive && this.direction !== 'descending'
                    ? 'descending'
                    : 'ascending'
            }`
        });
    };

    render() {
        const { label, style } = this.props;
        const sorted = this.isActive ? this.direction : null;

        return (
            <Table.HeaderCell
                sorted={sorted}
                onClick={this.handleClick}
                className="events-table-cell-padding"
                style={style}
            >
                {label}
            </Table.HeaderCell>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    sort: (state, props) => {
        const { namespace } = props;
        return makeSelectQueryStringValue(
            `${namespace ? `${namespace}_` : ''}sort`
        )(state, props);
    }
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(TableHeadTableCell);
